import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Overview from './pages/Overview';
import StrategicDashboard from './pages/StrategicDashboard';
import IBrief from './pages/IBrief';
import PerformanceCockpit from './pages/PerformanceCockpit';
import CaseDetail from './pages/CaseDetail';
import CasesAlerts from './pages/CasesAlerts';
import Settings from './pages/Settings';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/login" element={<Login data-id="element-3" />} data-id="element-2" />
        <Route path="/*" element={<ProtectedRoute data-id="element-5">
              <Layout data-id="element-6">
                <Routes data-id="element-7">
                  <Route path="/" element={<Overview data-id="element-9" />} data-id="element-8" />
                  <Route path="/strategic-dashboard" element={<StrategicDashboard data-id="element-11" />} data-id="element-10" />
                  <Route path="/ibrief" element={<IBrief data-id="element-13" />} data-id="element-12" />
                  <Route path="/performance" element={<PerformanceCockpit data-id="element-15" />} data-id="element-14" />
                  <Route path="/case/:id" element={<CaseDetail data-id="element-17" />} data-id="element-16" />
                  <Route path="/cases" element={<CasesAlerts data-id="element-19" />} data-id="element-18" />
                  <Route path="/settings" element={<Settings data-id="element-21" />} data-id="element-20" />
                </Routes>
              </Layout>
            </ProtectedRoute>} data-id="element-4" />
      </Routes>
    </Router>;
}